<template>
  <div>
    <template v-for="part in parsedHtml">
      <v-btn
        v-if="part == '[button=for-employers]'"
        color="primary"
        to="/for-employers"
        :key="part"
        >Jobs in Finland for employers</v-btn
      >
      <submit-position
        v-else-if="part == '[button=submit-job]'"
        color="primary"
        to="/for-employers"
        :key="part"
        :dialog="showDialog"
        >Submit job</submit-position
      >
      <contact-form
        v-else-if="part == '[button=contact-form]'"
        color="primary"
        to="/for-employers"
        :key="part"
        >Contact form</contact-form
      >
      <div v-else-if="part == '[block=cookie-declaration]'" class="cookie-declaration" :key="part">
        <script id="CookieDeclaration" src="https://consent.cookiebot.com/ba0397f0-bff4-48ec-9d50-acdb2a331a10/cd.js"
              type="application/javascript" defer async></script>
      </div>
      <div v-else v-html="part" :key="part">{{ part }}</div>
    </template>
  </div>
</template>
<script>
import SubmitPosition from "@/components/SubmitPosition.vue";
import ContactForm from "@/components/ContactForm.vue";

export default {
  name: "ContentRenderer",
  components: {
      SubmitPosition,
      ContactForm
  },
  props: {
      content: {
          type: String,
          required: true
      }
    },
  data(){
      return {}
  },
  computed: {
    parsedHtml() {
      let parts = this.content.split(/(\[button.*\]|\[block.*\])/);
      return parts;
    },
    showDialog(){
      console.log(this.$route.query.showSubmit);
      let showSubmit = this.$route.query.showSubmit == true;
      return showSubmit;
    }
  },
};
</script>
<style scoped></style>